import { Component } from '@angular/core';
import { FormBuilder,FormGroup,Validators  } from '@angular/forms';
import {  LoadingController,AlertController  } from 'ionic-angular';
import { UsuarioDAO } from '../../daos/usuario-dao';
import { Empresa } from '../../entities/empresa';
import { AppModule } from '../../app/app.module';


@Component({
    selector: 'page-enviar-email-senha',
    templateUrl: 'enviar-email-senha.html'
})
export class EnviarEmailSenhaPage {
  public empresaLogada : Empresa = new Empresa();
  formRedefinirSenha: FormGroup;
  cpf : string;
  constructor(private formBuilder: FormBuilder, private _loadingCtrl: LoadingController
    ,private _alertCtrl: AlertController,private _usuarioDao: UsuarioDAO) {
      this.empresaLogada =  AppModule.getEmpresa();
        this.formRedefinirSenha = this.formBuilder.group({
        Cpf: ['', Validators.compose([Validators.required])]
      });
    }

    alertaDeSucesso(msg: string) {
      this._alertCtrl.create({
          message: msg,
          title: 'Sucesso 😀 ️',
          buttons: [{
              text: 'Ok'
          }]
      }).present();
    }

    alertaErro(msg: string) {
      this._alertCtrl.create({
          message: msg,
          title: 'Ops... 😔',
          buttons: [{
              text: 'Ok, estou ciente'
          }]
      }).present();
    }

    enviarEmail(): void {
      if (this.formRedefinirSenha.valid) {   
        let loading = this._loadingCtrl.create({
                content: 'Enviando email...'
            });
            loading.present();
            this._usuarioDao.recuperarSenhaUsuario(this.cpf,this.empresaLogada.Id).then(() => {
            this.alertaDeSucesso('Verifique sua caixa de email!');
            loading.dismiss();
            }).catch((err) => {
                loading.dismiss();
                this.alertaErro(`Houve um erro inesperado. ${err.mensagem}`);
            });
        }
      
    }



}


// WEBPACK FOOTER //
// ./src/pages/enviar-email-senha/enviar-email-senha.ts